import { render, staticRenderFns } from "./QueryPlotchart.vue?vue&type=template&id=46a32e2b&scoped=true"
import script from "./QueryPlotchart.vue?vue&type=script&lang=js"
export * from "./QueryPlotchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a32e2b",
  null
  
)

export default component.exports